import {
	GET_CAMPAIGNS,
	FETCH_CAMPAIGN,
	UPDATE_CAMPAIGN,
	DELETE_CAMPAIGN,
	UPDATE_CAMPAIGN_PAGE_NUMBER,
} from "constants/actions";

const initialState = {
	campaigns: [],
	pageNumber: 1,
	pending: false,
	updated: false,
	created: [],
	queryParams: [],
};

export default function ActionCampaign(state = initialState, action) {
	switch (action.type) {
		case UPDATE_CAMPAIGN_PAGE_NUMBER:
			return {
				...state,
				pageNumber: action.payload,
			};

		case GET_CAMPAIGNS:
			return {
				...state,
				campaigns: action.payload,
				pending: false,
				updated: false,
			};

		case FETCH_CAMPAIGN:
			return {
				...state,
				[action.payload.id]: action.payload,
				pending: false,
			};

		case UPDATE_CAMPAIGN:
			if (state.campaigns && Array.isArray(state.campaigns)) {
				const exists = state.campaigns.find((c) => c.id === action.payload.id);
				const campaigns = exists
					? state.campaigns.map((c) => (c.id === action.payload.id ? action.payload : c))
					: [...state.campaigns, action.payload];

				return {
					...state,
					campaigns,
					[action.payload.id]: action.payload,
					pending: false,
					updated: action.payload,
				};
			}

			return {
				...state,
				[action.payload.id]: action.payload,
				pending: false,
				updated: action.payload,
			};

		case DELETE_CAMPAIGN:
			return {
				...state,
				campaigns: (state.campaigns || []).filter((row) => row.id !== action.payload),
				pending: false,
				updated: true,
			};

		default:
			return state;
	}
}

